module.exports = __webpack_public_path__ + "static/media/14.f5e39c56.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/14.png
// module id = 973
// module chunks = 0